import { cleanOutboxFolder } from '@launcher/helpers/desktop';
import { selectDesktopSettings } from '@store/desktop/desktop.selector';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

export function useCleanOutbox() {
  const settings = useSelector(selectDesktopSettings);

  return useCallback(() => cleanOutboxFolder([settings.watchPath], 0), [settings]);
}
